import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getInquiryStatuses } from '@api/lookups';
import { IInquiryStatus } from '@interfaces/lookups';

export const handleGetInquiryStatuses = createAsyncThunk<AxiosResponse<IInquiryStatus[]>, void>(
  'getInquiryStatuses',
  getInquiryStatuses,
);
